import * as React from "react";

const SvgComponent = ({ width = "37px", height = "22px", color = "green", ...props }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    className="battery-icon"
    viewBox="0 0 25 15"
    {...props}
  >
    <path
      d="M22.75 12.75v-2h.75c.808 0 1.5-.692 1.5-1.5v-3.5c0-.807-.692-1.5-1.5-1.5h-.75v-2c0-.807-.693-1.5-1.5-1.5h-20C.442.75 0 1.5 0 2.306v10.388c0 .807.442 1.556 1.25 1.556h20c.807 0 1.5-.692 1.5-1.5ZM2 12.75c-.073 0-.25-.176-.25-.25V2.75c0-.073.177-.25.25-.25h18.75c.073 0 .25.177.25.25v9.75c0 .073-.177.25-.25.25H2ZM2.25 3v9.25H20.5V3.06l-18.25-.06Z"
      fill={color}
    />
    <path
      d="M10.88 3v4.171L4 5.22 13.12 12V7.829L20 9.78 10.88 3Z"
      fill="#fff"
    />
  </svg>
);

export default SvgComponent;